module.exports = __webpack_public_path__ + "img/id-verifing.a95f8414.jpg";